
import EUsersTypes from '../../enums/EUsersTypes'
import { displayMessage } from "../../helpers/messages"
import { DateTime } from 'luxon'

const dateFormat = 'dd/LL/yyyy'

export default [
    {
        field: 'id',
        headerName: 'Código',
        width: 100

    },
    {
        field: 'full_name',
        headerName: displayMessage('FIRST_NAME'),
        valueGetter: (params) => params.row.full_name || '',
        width: 220

    },
    {
        field: 'email',
        headerName: displayMessage('EMAIL'),
        valueGetter: (params) => params.row.email || '',
        width: 220

    }
]